import styles from "./stats-container.module.css";

export default function StatsContainer({ stats }) {
    return (
        <div className={styles.statsContainer}>
            <div className={styles.statCard}>
                <span className={styles.statLabel}>Total Strategies</span>
                <span className={styles.statValue}>{stats.total_strategies}</span>
            </div>
            <div className={styles.statCard}>
                <span className={styles.statLabel}>Successfully Sent</span>
                <span className={styles.statValue}>{stats.successful_strategies}</span>
            </div>
            <div className={styles.statCard}>
                <span className={styles.statLabel}>Failed to Send</span>
                <span className={styles.statValue}>{stats.failed_strategies}</span>
            </div>
            <div className={styles.statCard}>
                <span className={styles.statLabel}>Last 30 Days</span>
                <span className={styles.statValue}>{stats.recent_strategies}</span>
            </div>
        </div>
    )
}